class PairsWellWith extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.currentEffect = 'all';
    this.isFetchingRecommendations = false;
    this.shouldRefetch = false;
    this.swiper = null;
    this.initRecommendations();
    this.initEffects();
  }

  initRecommendations() {
    if (this.isFetchingRecommendations) return;

    const url = this.dataset.url;
    if (!url) return;

    this.isFetchingRecommendations = true;

    const sliderElement = this.querySelector('.pairs-well-with-swiper');
    if (sliderElement) sliderElement.classList.add('loading');
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;

        const sectionId = this.dataset.sectionId;
        const selector = sectionId ? `[data-product-recommendations][data-section-id="${sectionId}"]` : '[data-product-recommendations]';
        const recommendations = html.querySelector(selector);

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          this.dispatchEvent(new CustomEvent('pairs-well-with:loaded', { bubbles: true }));
        }

        this.applyActiveEffect();
        this.removeNonMatchingSlides();
        this.initSwiper();
      })
      .catch((error) => {
        console.error('Pairs well with recommendations failed to load', error);
      })
      .finally(() => {
        this.isFetchingRecommendations = false;
        if (sliderElement) sliderElement.classList.remove('loading');

        if (this.shouldRefetch) {
          this.shouldRefetch = false;
          this.initRecommendations();
        }
      });
  }

  initSwiper() {
    const sliderElement = this.querySelector('.pairs-well-with-swiper');
    if (!sliderElement) return;

    if (this.swiper) this.swiper.destroy(true, true);

    this.swiper = new Swiper(sliderElement, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      centerInsufficientSlides: true,
      breakpoints: {
        1024: {
          spaceBetween: 40,
        },
      },

      // on: {
      //   init: function () {
      //     this.slideTo(1);
      //   },
      // },
    });
  }

  applyActiveEffect() {
    this.querySelectorAll('[data-btn-effect]').forEach((button) => {
      const isActive = button.dataset.btnEffect === this.currentEffect;
      button.classList.toggle('active', isActive);
    });
  }

  removeNonMatchingSlides() {
    const slides = this.querySelectorAll('.swiper-slide[data-effect]');
    if (!slides.length) return;

    if (this.currentEffect === 'all') return;

    slides.forEach((slide) => {
      if (slide.dataset.effect !== this.currentEffect) {
        slide.remove();
      }
    });
  }

  initEffects() {
    if (this.dataset.effectsBound === 'true') return;
    this.dataset.effectsBound = 'true';

    this.addEventListener('click', (event) => {
      const effectButton = event.target.closest('[data-btn-effect]');
      if (!effectButton || !this.contains(effectButton)) return;

      event.preventDefault();
      const nextEffect = effectButton.dataset.btnEffect || 'all';
      if (nextEffect === this.currentEffect) return;

      this.currentEffect = nextEffect;
      this.applyActiveEffect();

      if (this.isFetchingRecommendations) {
        this.shouldRefetch = true;
        return;
      }

      this.initRecommendations();
    });
  }
}

if (!customElements.get('pairs-well-with')) {
  customElements.define('pairs-well-with', PairsWellWith);
}
